import { oz } from '@weft/utils';

export const REPORT_JOB_STATUSES = Object.freeze({
  Pending: 'Pending',
  Cancelled: 'Cancelled',
  Completed: 'Completed',
  Failed: 'Failed',
});

export const ReportJobStatusesSchema = oz.nativeEnum(REPORT_JOB_STATUSES);

export type ReportJobStatuses = oz.infer<typeof ReportJobStatusesSchema>;